export const DEFAULT_WORKFLOW_SCRIPT = `// ===== 可用變數 =====
// ctx.service  - Service 物件，包含各種 API 呼叫
//   - service.order.getRecords(params)    - 訂單列表
//   - service.order.get(id)               - 訂單詳情
//   - service.order.cancel(id)            - 取消訂單
//   - service.product.getRecords(params)  - 商品列表
//   - service.inventory.getRecords(params) - 庫存列表
//   - ... 更多請參考 AI 助手
// ctx.inputs   - 使用者輸入的值 (由 ui_config.inputs 定義)
// ctx.React    - React
// ctx.AntD     - 所有 antd 組件 (Table, Button, Tag, Card, Space...)
// ctx.Icons    - 所有 antd icons (SearchOutlined, EditOutlined...)

const { service, inputs, React, AntD, Icons } = ctx
const { Table, Tag, Button, Space, message } = AntD
const { SearchOutlined, EditOutlined } = Icons

// ===== 呼叫 API =====
// 使用 service.{domain}.{method}() 格式
const res = await service.order.getRecords({ page_size: 20 })
const data = res.data || []

// ===== 回傳 render function =====
return () => {
  const columns = [
    {
      title: '訂單編號',
      dataIndex: 'name',
      key: 'name',
      width: 150
    },
    {
      title: '狀態',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status) => React.createElement(Tag, {
        color: status === 'shipped' ? 'green' : status === 'canceled' ? 'red' : 'blue'
      }, status)
    },
    {
      title: '收件人',
      dataIndex: 'receiver_name',
      key: 'receiver_name'
    },
    {
      title: '操作',
      key: 'action',
      width: 100,
      render: (_, record) => React.createElement(
        Button,
        {
          size: 'small',
          icon: React.createElement(EditOutlined),
          onClick: () => window.open('/admin/orders/' + record.id, '_blank')
        },
        '查看'
      )
    }
  ]

  return React.createElement(Table, {
    columns,
    dataSource: data,
    rowKey: 'id',
    size: 'small',
    pagination: { pageSize: 10 }
  })
}`
